import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { agentSliceAction } from '../../store/agentSlice';
import { millisecondsToHMS } from '../../utils/utils';
import TooltipCallMerge from './CallsTooltip/TooltipCallMerge';
import TooltipCallSwip from './CallsTooltip/TooltipCallSwip';
import TooltipCallMute from './CallsTooltip/TooltipCallMute';
import TooltipCallUnmute from './CallsTooltip/TooltipCallUnmute';
import TooltipCallEnd from './CallsTooltip/TooltipCallEnd';
import TooltipCallQuickConnect from './CallsTooltip/TooltipCallQuickConnect';
import TooltipCallHold from './CallsTooltip/TooltipCallHold';
import TooltipCallResume from './CallsTooltip/TooltipCallResume';
import TooltipCallLeave from './CallsTooltip/TooltipCallLeave';
import TooltipCallDialpad from './CallsTooltip/TooltipCallDialpad';
import { FiPhoneCall, FiPhone, FiPhoneMissed } from "react-icons/fi"


import { Button, Modal } from 'react-bootstrap';
import { MdOutlineErrorOutline, MdOutlineBackspace } from "react-icons/md";
import { BsXLg } from "react-icons/bs";
import CountryCode from '../../config/countryCodes.json';
import { getMaskNumbersData, postCallbackID } from '../../utils/utils';
import sound from '../../assets/audio/Dialpad.wav';
import TooltipCallBargeIn from './CallsTooltip/TooltipCallBargeIn';






const Dialpad = () => {
    
    const clickSound = new Audio(sound);
    const dispatch = useDispatch()
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const contactObj = useSelector((state:any)=>{return state.contactSlice.contactObj})
    const maskNumber = useSelector((state:any)=>{return state.agentSlice.maskNumber})
    const [agentCurrentState, setAgentCurrentState] = useState<any>("");
    const [dialNumber, setDialNumber] = useState<any>("");
    const [country, setCountry] = useState<any>({"name":"United States of America", "flag":"images/flags/us.png","code":"+1"})
    const [callError, setCallError] = useState<any>("")
    const [show, setShow] = useState(false);
    const handleClose = () => {setShow(false);setSelectedQuickConnect("-----");setDialNumber("")};
    const handleShow = () => setShow(true);
    const [maskNumberData, setMaskNumberData] = useState<any>([])
    const [quickContactList, setQuickContactList] = React.useState([]);
    const [SelectedQuickConnect, setSelectedQuickConnect ] = useState<string>("------");
    // quick connects
    const getQuickContactListNumbers = async () => {
        let routingProfile = agentObj.getRoutingProfile();
        agentObj.getEndpoints([routingProfile.defaultOutboundQueue.queueARN],{
        success: function(data:any){
            let PhoneNumbers =data.endpoints.filter((endpoints:any) => endpoints.type === "phone_number");
            setQuickContactList(PhoneNumbers);
            
        },
        failure:function(){
    
        }
        });
    }
    //quick connects



    useEffect(() => {
        if(agentObj) {
            setMaskNumberData(getMaskNumbersData(agentObj.getRoutingProfile().name))
            setAgentCurrentState(agentObj.getState().name)
            agentObj?.onRefresh(() => {
                setAgentCurrentState(agentObj.getState().name)
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[agentObj])

    const onDialNumber = (number:string) => {
        if(agentCurrentState === "Busy") {
            contactObj?.getAgentConnection().sendDigits(number, {
                success: function() { 
                    console.log("Digit send successfully")
                },
                failure: function(err:any) { /* ... */ }
            });
        }

        let inputData = dialNumber+number;
        let result = "";
        if(inputData.length > 3) {
            result = inputData.substring(0, 4);
        } else {
            result = inputData
        }
        CountryCode.filter((item:any) => {
            if(item.code === result) {
                setCountry(item)
                return item
            }
            return false;
        })
        clickSound.play();
        setDialNumber(dialNumber+number);
        setCallError("")
    }

    const onChangeNumber = (event:any) =>{
        const Regx = new RegExp("[0-9,+]")
        const inputNumber = event.target.value;
        const inputValueArray = inputNumber.split("")
        let validNumbers:any = []

        inputValueArray.map((digit:any) => {
            if(Regx.test(digit)) {
                if(agentCurrentState === "Busy") {
                    contactObj?.getAgentConnection().sendDigits(digit, {
                        success: function() { 
                            console.log("Digit send successfully")
                        },
                        failure: function(err:any) { /* ... */ }
                        });
                }
                validNumbers.push(digit)
                let inputData = validNumbers.join("");
                let result = "";
                if(inputData.length > 3) {
                    result = inputData.substring(0, 4);
                } else {
                    result = inputData
                }
                CountryCode.filter((item:any) => {
                    if(item.code === result) {
                        setCountry(item)
                        return item
                    }
                    return false;
                })
                clickSound.play();
            }
            return 0;
        })
        setDialNumber(validNumbers.join(""))
        setCallError("")
    }

    const onClear = () => {
        setDialNumber("")
        setCallError("")
    }

    const onClickBack = () => {
        let newNumber = dialNumber.slice(0, -1)
        setDialNumber(newNumber)
        setCallError("")
    }

    const onMakeCall = () => {        
        if(dialNumber !== '') {
            let checkPluseSign = dialNumber.substring(0, 1)
            let finalNumber = (checkPluseSign !== "+") ? country.code+dialNumber : dialNumber;
            const endpoint = connect.Endpoint.byPhoneNumber(finalNumber);
            if(agentCurrentState === "Busy") {
                setDialNumber(finalNumber)
                contactObj.addConnection(endpoint, {
                    success: function() {
                        console.log("ConnectionComponent::AddInCall::Add In Call Success");
                        handleClose()
                        setDialNumber("");
                        setCallError("")
                    },
                    failure: function(err:any) {
                        let error = JSON.parse(err)
                        if(error.type === 'BadEndpointException') {
                            setCallError("Phone number is invalid")
                        }
                        console.log("ConnectionComponent::AddInCall::Add In Call Failed");
                    }
                })
            } else {
                agentObj.connect(endpoint,{
                    success:function() {
                        console.log("outbound call connected")
                        handleClose()
                        setDialNumber("");
                        setCallError("")
                    },
                    failure:function(err:any) {
                        let error = JSON.parse(err)
                        if(error.type === 'BadEndpointException') {
                            setCallError("Phone number is invalid")
                        }
                    }
                })
            }
        }
    }

    const onChangeCountry = (countryData:any) => {
        setCountry(countryData)
        setDialNumber(countryData.code+dialNumber)
    }

    const onMaskNumberChange = (element:any) => {
        
        if(agentObj) {
            let username = agentObj?.getConfiguration()?.username || "No agent";
            let CBNumber = element.ElementValue;
            dispatch(agentSliceAction.setMaskNumber(CBNumber))
            postCallbackID(username, CBNumber)
        }
    }

    return (
        <React.Fragment>
            {/* <Button className='dailbox bg-primary' onClick={handleShow}>
                <span className='dailbox-icon'><FiPhoneCall /></span>
            </Button> */}

            <button aria-label="Transfer dial pad" onClick={handleShow} className='btn-icon' >
                <TooltipCallDialpad/>
            </button>

            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
                <Modal.Header className='dailpad-header'>
                    <Modal.Title>Dialpad</Modal.Title>
                    <button className='close-btn-x' onClick={handleClose}>
                        <BsXLg/>
                    </button>
                    
                </Modal.Header>
                <Modal.Body>
                    <div className='row' onKeyPress={(e)=>{if (e.key ==="Enter"){onMakeCall()}}}>
                        <div className='col-12'>
                        <h5 className='text-darkblue text-center b-bottom'> Outgoing call</h5>
                        <div className='d-flex justify-content-center SubMenus'>
                            
                            {quickContactList.length > 0 && <div className="dropdown">
                            <label className="MaskNumber">QuickConnects</label>
                                <button type="button" className="btn btn-sm dropdown-toggle btn-outline-orange" data-bs-toggle="dropdown">
                                {SelectedQuickConnect || '------'}
                                </button>
                                    <ul className="dropdown-menu">
                                        {quickContactList.map(({ phoneNumber, name }) => 
                                        <li key={phoneNumber}><button onClick={()=>{
                                            setDialNumber(phoneNumber)
                                            setSelectedQuickConnect(name)
                                        }} className="dropdown-item">{name}</button></li>)
                                        }                                               
                                    </ul>
                            </div> }
                            
                          
                        </div>
                        <div className='d-flex justify-content-center SubMenus'>
                            {maskNumberData.length > 0 &&

                            
                                <div className="dropdown">
                                    <label className="MaskNumber">Account name</label>
                                    <button type="button" className="btn btn-sm dropdown-toggle btn-outline-orange" data-bs-toggle="dropdown">
                                        {maskNumber || '------'}
                                    </button>
                                    <ul className="dropdown-menu">
                                        {maskNumberData && maskNumberData.map((item:any,index:number) =>{
                                            return (
                                                <li key={index}>
                                                    <button onClick={()=>{onMaskNumberChange(item)}} className="dropdown-item"> 
                                                        {item.ElementName}
                                                    </button>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>

                            }


                        </div>
                     
                        <div className='call-input-box'>
                                
                            <div className='call-box'>
                                <div className='call-input-icon'><FiPhoneCall /></div>
                                <div className="dropdown flag-box">
                                    <button type="button" className="dropdown-toggle me-3" data-bs-toggle="dropdown">
                                    <span className='flag-value'><img className='logo-src' src={country.flag} alt="flag" /></span>
                                    </button>
                                    <ul className="dropdown-menu flag-list">
                                        {CountryCode && CountryCode.map((country:any, index:number) => {
                                            return (
                                                <li onClick={()=>{ onChangeCountry(country) }} key={index}>
                                                    <span className='flag-img'><img className='logo-src' src={country.flag } alt="flag" /></span> 
                                                    <span className='c-name'>{country.name}</span> 
                                                    <span className='c-code'>{country.code}</span>
                                                </li>        
                                            )
                                        })}
                                    </ul>
                                </div>   
                                <div className='call-input'>                                    
                                    <input value={dialNumber} autoFocus onChange={(event)=>{onChangeNumber(event)}} type="text" placeholder='Enter number here' />
                                </div>
                            </div>
                        </div>
                            {callError && <div className='error-text text-danger text-center'><MdOutlineErrorOutline /> {callError} </div>}
                            <div className='col-12'>
                                <div className="dailpaid-box">
                                    <div className="keypad-wapper">
                                        <div className="keypad-row">
                                            <button onClick={()=>{onDialNumber("1")}} value="1" className="key-button border-rb">
                                                <div className="number-key">1</div>
                                            </button>
                                            <button onClick={()=>{onDialNumber("2")}} value="2" className="key-button border-rb">
                                                <div className="number-key">2</div>
                                            </button>
                                            <button onClick={()=>{onDialNumber("3")}} value="3" className="key-button border-b">
                                                <div className="number-key">3</div>
                                            </button>
                                        </div>
                                        <div className="keypad-row">
                                            <button onClick={()=>{onDialNumber("4")}} value="4" className="key-button border-rb">
                                                <div className="number-key">4</div>
                                            </button>
                                            <button onClick={()=>{onDialNumber("5")}} value="5" className="key-button border-rb">
                                                <div className="number-key">5</div>                                    
                                            </button>
                                            <button onClick={()=>{onDialNumber("6")}} value="6" className="key-button border-b">
                                                <div className="number-key">6</div>
                                            </button>
                                        </div>
                                        <div className="keypad-row">
                                            <button onClick={()=>{onDialNumber("7")}} value="7" className="key-button border-rb">
                                                <div className="number-key">7</div>
                                            </button>
                                            <button onClick={()=>{onDialNumber("8")}} value="8" className="key-button border-rb">
                                                <div className="number-key">8</div>
                                            </button>
                                            <button onClick={()=>{onDialNumber("9")}} value="9" className="key-button border-b">
                                                <div className="number-key">9</div>
                                            </button>
                                        </div>
                                        <div className="keypad-row">
                                            <button onClick={()=>{onDialNumber("*")}} value="*" className="key-button border-rb">
                                                <div className="number-key">*</div>
                                            </button>
                                            <button onClick={()=>{onDialNumber("0")}} value="0" className="key-button border-rb">
                                                <div className="number-key">0</div>
                                                
                                            </button>
                                            <button onClick={()=>{onDialNumber("#")}} value="#" className="key-button border-b">
                                                <div className="number-key">#</div>
                                            </button>
                                        </div>
                                        <div className="keypad-row">
                                            <button onClick={()=>{onClear()}} className="key-button border-r">
                                                <div className="number-key"><i className="far fa-trash-alt"></i></div>
                                            </button>
                                            <button onClick={()=>{onDialNumber("+")}} className="key-button border-r">
                                                <div className="char-key">+</div>
                                            </button>
                                            <button onClick={()=>{onClickBack()}} className="key-button">
                                                <div className="number-key"><MdOutlineBackspace /></div>
                                            </button>
                                        </div>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <Button onClick={()=>{onMakeCall()}} className='w-100 btn btn-success btn-lg'><FiPhoneCall/> Call</Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}


const CallingInfo = () => {
    const dispatch = useDispatch()
    const contactObj = useSelector((state:any)=>{return state.contactSlice.contactObj})
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const isAgentMute = useSelector((state:any)=>{return state.agentSlice.isAgentMute})
    const [agentCurrentState, setAgentCurrentState] = useState<any>("");
    const [connections, setConnections ] = useState<any>([]);
    const [holdConnectionCount, setHoldConnectionCount] = useState<any>(0);
    const [quickContactList, setQuickContactList] = React.useState([]);
    const [stateDuration, setStateDuration] = React.useState("00:00:00")
    const [monitoringConnections, setMonitoringConnections] = React.useState<any>([])
    const [holdTime, setHoldTime] = useState(Math.round(Date.now() / 1000) - (Number(localStorage.getItem("holdStart")) > 0 ? Number(localStorage.getItem("holdStart")) : Math.round(Date.now() / 1000)));
    const [isOnHold, setIsOnHold] = useState(false);
    const [muteTime, setMuteTime] = useState(Math.round(Date.now() / 1000) - (Number(localStorage.getItem("muteStart")) > 0 ? Number(localStorage.getItem("muteStart")) : Math.round(Date.now() / 1000)));
    const [isOnMute, setIsOnMute] = useState(false);
    const [search, setSearch] = useState("");
    const [matches, setMatches] = useState<any[]>([]);

    useEffect(() => {
        let interval:any;
        if(contactObj) {
            try {
                let snapshotData = contactObj?.toSnapshot()
                let connectionsList = snapshotData?.contactData?.connections.filter((connection:any) => (connection.type !== "agent" && connection?.state?.type !== 'disconnected'))
                setConnections(connectionsList)
                let monitoringConnectionList = snapshotData?.contactData?.connections.filter((connection:any) => (connection.type === "monitoring" && (connection?.state?.type !== 'disconnected' && connection?.state?.type !== 'ended') ))
                setMonitoringConnections(monitoringConnectionList)
                let holdConnections = connectionsList.filter((connection:any) => connection?.state?.type === 'hold')
                let holdConnCount = (holdConnections)?holdConnections.length:0
                setHoldConnectionCount(holdConnCount)
                setAgentCurrentState(agentObj.getState().name)
    
                contactObj?.onRefresh(() => {
                    let snapshotData = contactObj?.toSnapshot()
                    let connectionsList = snapshotData?.contactData?.connections.filter((connection:any) => (connection.type !== "agent" && connection?.state?.type !== 'disconnected'))
                    setConnections(connectionsList)
                    let monitoringConnectionList = snapshotData?.contactData?.connections.filter((connection:any) => (connection.type === "monitoring" && (connection?.state?.type !== 'disconnected' && connection?.state?.type !== 'ended') ))
                    setMonitoringConnections(monitoringConnectionList)
                    let holdConnections = connectionsList.filter((connection:any) => connection?.state?.type === 'hold')
                    let holdConnCount = (holdConnections)?holdConnections.length:0
                    setHoldConnectionCount(holdConnCount)
                    setAgentCurrentState(agentObj.getState().name)
                })
                interval = setInterval(() => {
                    try {
                        if(contactObj.getState().type === 'connecting' || contactObj.getState().type === 'connected') {
                            let durationInMillis = contactObj?.getStatusDuration()
                            let hms = millisecondsToHMS(durationInMillis);
                            setStateDuration(hms)
                        }
                    } catch (err) {
                        console.log(err)
                        clearInterval(interval)
                    }
                }, 1000);
            } catch (error) {
                console.log(error)
                clearInterval(interval)
            }
        }
        return()=>{
            clearInterval(interval)
        }
    },[contactObj, agentObj])

    useEffect(() => {
        let interval: any;
        if(localStorage.getItem("isOnHold") === "true") {
            interval = setInterval(() => {
                setHoldTime(Math.round(Date.now() / 1000) - Number(localStorage.getItem("holdStart")));
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return() => clearInterval(interval);
    }, [isOnHold, holdTime])

    useEffect(() => {
        let interval: any;
        if(localStorage.getItem("isOnMute") === "true") {
            interval = setInterval(() => {
                setMuteTime(Math.round(Date.now() / 1000) - Number(localStorage.getItem("muteStart")));
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return() => clearInterval(interval);
    }, [isOnMute, muteTime])
    
    const onChangeMuteStatus = () => {
        if(agentObj){
            if(localStorage.getItem("isOnMute") === "true") {
                agentObj.unmute()
                setIsOnMute(false);
                setMuteTime(0);
                localStorage.setItem("isOnMute", "false");
                localStorage.setItem("muteStart", "0");

            } else {
                agentObj.mute()
                setIsOnMute(true);
                localStorage.setItem("isOnMute", "true");
                localStorage.setItem("muteStart", (Math.round(Date.now() / 1000)).toString());
            }
            dispatch(agentSliceAction.setIsAgentMute(!isAgentMute))
        }
    }

    const onAcceptCall = () => {
		contactObj.accept({
			success:function(){
				console.log("ConnectionComponent::onAcceptCall::Call Accepted Succesfully");				
			},
			failuer:function(err:any){
				console.log("ConnectionComponent::onAcceptCall::Error in Call Accept"+err);				
			}
        })
    }

    const onDestroy = (connectionId:any) => {
        let activeConnection = contactObj?.getConnections();
        let selectedConnection = activeConnection.filter((item:any)=>{ return item.connectionId === connectionId })[0];
        selectedConnection.destroy({
            success:function(){
                console.log("ConnectionComponent::onDestroy::Destory Success");
            },
            failuer:function(err:any){
                console.log("ConnectionComponent::onDestroy::Destory Error"+err);				
            }  
        })
    }

    const onAgentLeave = () => {
        contactObj?.getAgentConnection().destroy({
            success:function(){
                console.log("ConnectionComponent::leaveCall::Leave Call Successfully");
            },
            failuer:function(err:any){
                console.log("ConnectionComponent::leaveCall::Leave Call Failed"+err);				
            }  
        })
    }



    const onBargeInCall = () => {
        let activeConnection = contactObj;
        activeConnection.updateMonitorParticipantState(connect.ConnectionStateType.BARGE, {
            success: function() { 
             console.log("Successfully changed the monitoring status to barge, now you can control the conversation")
            },
            failure: function() { 
             console.log("Somenting went wrong, here is the error ") 
            }
           });

    }



    const onHoldCall = (connectionId:any, status:boolean) => {
        let activeConnection = contactObj?.getConnections();
        let selectedConnection = activeConnection.filter((item:any)=>{ return item.connectionId === connectionId })[0];
        if(status){
            selectedConnection.resume({
                success:function(){
                    setIsOnHold(false);
                    localStorage.setItem("isOnHold", "false");
                    setHoldTime(0);
                    localStorage.setItem("holdStart", "0");
                    console.log("ConnectionComponent::onHoldCall::Call Connection Resume Succesfully.");
                },
                failuer:function(err:any){
                    console.log("ConnectionComponent::onHoldCall::Error in Call Connection Resume."+err);				
                } 
            })
        } else {
            selectedConnection.hold({
                success:function(){
                    setIsOnHold(true);
                    localStorage.setItem("isOnHold", "true");
                    localStorage.setItem("holdStart", (Math.round(Date.now() / 1000)).toString());
                    console.log("ConnectionComponent::onHoldCall::Call Connection Hold Succesfully.");
                },
                failuer:function(err:any){
                    console.log("ConnectionComponent::onHoldCall::Error in Call Connection Hold."+err);				
                }
            })
        }
    }

    const getQuickContactList = async () => {
        let routingProfile = agentObj.getRoutingProfile();
        agentObj.getEndpoints([routingProfile.defaultOutboundQueue.queueARN],{
            success: function(data:any){
                setQuickContactList(data.endpoints);
            },
            failure:function(){

            }
        });
    }

    const addInCall = (endpointId:any) => {
        const endPoint = quickContactList.find((list:any) => { return list.endpointId === endpointId })
        contactObj?.addConnection(endPoint,{
            success: function() {
                console.log("ConnectionComponent::AddInCall::Add In Call Success");
            },
            failure: function() {
                console.log("ConnectionComponent::AddInCall::Add In Call Failed");
            }
        })
    }

    const onSwapCall = () => {
        contactObj?.toggleActiveConnections({
            success:function(){
                console.log("ConnectionComponent::onSwapCall::Call Swap Success");
            },
            failure:function(err:any){
                console.log("ConnectionComponent::onSwapCall::Call Swap Failed");
            }
        })
    }

    const onJoinCall = () => {
        contactObj?.conferenceConnections({
            success:function(){
                console.log("ConnectionComponent::onJoinCall::Join Call Success");
            },
            failure:function(err:any){
                console.log("ConnectionComponent::onJoinCall::Join Call Failed");
            }
        })
    }

    const secondsToTimer = (time: number) => {
        var seconds = time % 60;
        var minutes = Math.floor(time / 60) % 60;
        var hours = Math.floor(Math.floor(time / 60) / 60);
    
        let str = "";
    
        if(hours !== 0){
            if(hours.toString().length < 2){
                str = str + "0" + hours + ":";
            }else{
                str = str + hours + ":";
            }
        }
    
        if(minutes.toString().length < 2){
            str = str +  "0" + minutes + ":";
        }else{
             str = str + minutes + ":";
        }
    
        if(seconds.toString().length < 2){
            str = str +  "0" + seconds;
        }else{
            str = str + seconds;
        }

        return str;
    }
    useEffect(()=>{
    const onChangeSearch = setTimeout((event:any) => {
        searchMatches(search);
    },1000)
    return () => clearTimeout(onChangeSearch)},[search])

    const searchMatches = (input: string) => {
        let results : any[] = [];
        quickContactList.forEach((quickConnect: any) => {
            if((quickConnect["name"].toLowerCase()).includes(input.toLowerCase())) {
                results.push(quickConnect);
            }
        })
        setMatches(results);
    }
    
    return (
        <React.Fragment>
            {(agentCurrentState === "PendingBusy" || agentCurrentState === "Pending") &&
                <div className="card call-info collapse show mt-3" id="call_info">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className='m-0'>Calls</h6>
                        </div>
                        {connections && connections.map((connection:any, index:number) => {
                            return (
                                <ul key={index} className='calling-data list-unstyled mb-2'>
                                    <li style={{width:"230px"}}>
                                        <div>
                                            <div style={{width:"80px"}} className='call-type me-3'>
                                                <div>Call type</div>
                                                <div><strong>{connection?.type}</strong></div>
                                            </div>
                                            
                                            <div className='caller-name d-flex align-items-center'>
                                                <span className='calling-icon'><FiPhoneCall /></span>
                                                {connection?.endpoint?.name || 'unknown'}
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{width:"80px"}}>
                                        <div className='time-count'>{stateDuration}</div>
                                    </li>
                                    <li style={{width:"150px"}}>
                                        <div className='contact-number'>
                                            {connection?.endpoint?.phoneNumber || 'unknown'}
                                        </div>
                                    </li>
                                    <li style={{width:"115px"}}>
                                        <div className='contact-number'>
                                            {connection?.state?.type}
                                        </div>
                                    </li>
                                    <li style={{width:"250px"}}>
                                        <div>
                                            <button onClick={()=>{ onAcceptCall() }} className='btn-icon bg-success text-white'><FiPhone /></button>
                                            <button onClick={()=>{ onDestroy(connection.connectionId) }} className='btn-icon bg-danger text-white'><FiPhoneMissed /></button>
                                        </div>
                                    </li>
                                </ul>
                            )
                        })}   
                    </div>
                </div>
            }
            {(agentCurrentState === "Busy" || agentCurrentState === "CallingCustomer") &&
                <div className="card call-info collapse show mt-3" id="call_info">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className='m-0'>Calls</h6>
                        </div>
                        {connections && connections.map((connection:any, index:number) => {
                            return (
                                <ul key={index} className='calling-data list-unstyled mb-2'>
                                    <li style={{width:"230px"}}>
                                        <div>
                                            <div style={{width:"80px"}} className='call-type me-3'>
                                                <div>Call type</div>
                                                <div><strong>{connection?.type}</strong></div>
                                            </div>
                                            <div className='caller-name d-flex align-items-center'>
                                                <span className='calling-icon'><FiPhone /> </span>
                                                {connection?.endpoint?.name || 'unknown'}
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{width:"80px"}}>
                                        <div className='time-count'>{stateDuration}</div>
                                    </li>
                                    <li style={{width:"150px"}}>
                                        <div className='contact-number'>
                                            {connection?.endpoint?.phoneNumber || 'unknown'}
                                        </div>
                                    </li>
                                    <li style={{width:"115px"}}>
                                        <div className='contact-number'>
                                            {connection?.state?.type}
                                        </div>
                                    </li>
                                    {(connection?.state?.type !== 'connecting') && 
                                        <li style={{width:"150px"}}>
                                            <div>
                                                {(connection?.state?.type === 'connected') && <button aria-label="Hold" onClick={()=>{onHoldCall(connection.connectionId, false); setHoldTime(0);}} className='btn-icon'><TooltipCallHold /></button>}
                                                {(connection?.state?.type === 'hold') && <div><button aria-label="Resume" onClick={()=>{onHoldCall(connection.connectionId, true)}} className='btn-icon bg-orange text-white'><TooltipCallResume /></button><span>{secondsToTimer(holdTime)}</span></div>}
                                                {(connections.length > 1) && <button aria-label="Disconnect" onClick={()=>{ onDestroy(connection.connectionId) }} className='btn-icon bg-danger text-white'><TooltipCallEnd /></button>}
                                            </div>
                                        </li>
                                    }
                                    
                                    {(connection?.type !== 'monitoring') && 
                                    //monitoring no longer let us know it is monitoring, now it is a inbound call to the manager
                                        <li style={{width:"150px"}}>
                                            <div>
                                                {<button onClick={()=>{onBargeInCall()}} className='btn-icon'><TooltipCallBargeIn /></button>}
                                            </div>
                                        </li>
                                    }
                                    {(index === 0) && 
                                        <li style={{width:"400px"}}>
                                            <div>
                                                {(holdConnectionCount > 0 && agentCurrentState === 'Busy') && <button aria-label="Merge call" onClick={() => {onJoinCall()}}className='btn-icon'><TooltipCallMerge /></button>}
                                                {(holdConnectionCount > 0 && agentCurrentState === 'Busy') && <button aria-label="Swap call" onClick={() => (onSwapCall())}className='btn-icon'><TooltipCallSwip /></button>}
                                                {(agentCurrentState === 'Busy') && 
                                                    <div className="dropdown">
                                                        <button aria-label="Transfers" onClick={()=>{getQuickContactList()}} className='btn-icon' data-bs-toggle="dropdown"><TooltipCallQuickConnect /></button>
                                                        <ul className="dropdown-menu">
                                                            {
                                                                quickContactList.length > 0 ? 
                                                                <>
                                                                <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                                                                    <input maxLength={100} onChange={(event) => { setSearch(event.target.value) }} value={search} type="text" placeholder='Search for a Quick Connect' className='searchBar'/>
                                                                </div>
                                                                {search === "" ? (
                                                                    quickContactList.map(({ endpointId, name }) => 
                                                                        <li key={endpointId}><button onClick={()=>{addInCall(endpointId)}} className="dropdown-item">{name}</button></li>)
                                                                ) : (
                                                                    matches.map(({ endpointId, name }) => 
                                                                        <li key={endpointId}><button onClick={()=>{addInCall(endpointId)}} className="dropdown-item">{name}</button></li>)
                                                                )}   
                                                                </>
                                                            : <li><p style={{color: "white", textAlign: "center", marginTop: "1rem"}}>There are no Quick Connects available</p></li>
                                                            }
                                                                                                      
                                                        </ul>
                                                    </div>
                                                }
                                                {(isAgentMute) && <div><button aria-label="Unmute" onClick={() => {onChangeMuteStatus();}} className='btn-icon'><TooltipCallUnmute /></button><span style={{display:'inline-block' , marginRight:'2rem', width:'45px'}}>{secondsToTimer(muteTime)}</span></div>}
                                                {(!isAgentMute) && <button aria-label="Mute" onClick={() => {onChangeMuteStatus(); setMuteTime(0);}} className='btn-icon'><TooltipCallMute /></button>}
                                                <Dialpad/>
                                                <button aria-label="End call" onClick={()=>{ onAgentLeave() }} className='btn-icon bg-danger text-white'><TooltipCallLeave /></button>
                                            </div>
                                        </li>
                                    }
                                </ul>
                            )
                        })}   
                    </div>
                </div>
            }
            {monitoringConnections && monitoringConnections.length > 0 &&
                <div className="card call-info collapse show mt-3" id="call_info">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <h6 className='m-0'>Calls</h6>
                        </div>
                        {monitoringConnections && monitoringConnections.map((connection:any, index:number) => {
                            return (
                                <ul key={index} className='calling-data list-unstyled mb-2'>
                                    <li style={{width:"230px"}}>
                                        <div>
                                            <div style={{width:"80px"}} className='call-type me-3'>
                                                <div>Call type</div>
                                                <div><strong>{connection?.type}</strong></div>
                                            </div>
                                            <div className='caller-name d-flex align-items-center'>
                                                <span className='calling-icon'><FiPhone /></span>
                                                {connection?.endpoint?.name || 'unknown'}
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{width:"80px"}}>
                                        <div className='time-count'>{stateDuration}</div>
                                    </li>
                                    <li style={{width:"150px"}}>
                                        <div className='contact-number'>
                                            {connection?.endpoint?.phoneNumber || 'unknown'}
                                        </div>
                                    </li>
                                    <li style={{width:"115px"}}>
                                        <div className='contact-number'>
                                            {connection?.state?.type}
                                        </div>
                                    </li>
                                    <li style={{width:"250px"}}>
                                        <div>
                                            <button onClick={()=>{ onDestroy(connection.connectionId) }} className='btn-icon bg-danger text-white'><FiPhoneMissed /></button>
                                        </div>
                                    </li>
                                </ul>
                            )
                        })}   
                    </div>
                </div>
            }

        </React.Fragment>
    )
}
export default CallingInfo;